var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 23,
    viewBox: "0 0 37 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 22.75H34.8333C35.9563 22.75 36.875 21.9062 36.875 20.875C36.875 19.8438 35.9563 19 34.8333 19H2.16667C1.04375 19 0.125 19.8438 0.125 20.875C0.125 21.9062 1.04375 22.75 2.16667 22.75ZM2.16667 13.375H34.8333C35.9563 13.375 36.875 12.5312 36.875 11.5C36.875 10.4688 35.9563 9.625 34.8333 9.625H2.16667C1.04375 9.625 0.125 10.4688 0.125 11.5C0.125 12.5312 1.04375 13.375 2.16667 13.375ZM0.125 2.125C0.125 3.15625 1.04375 4 2.16667 4H34.8333C35.9563 4 36.875 3.15625 36.875 2.125C36.875 1.09375 35.9563 0.25 34.8333 0.25H2.16667C1.04375 0.25 0.125 1.09375 0.125 2.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.dabb80b5bd07c4e9563ad5aa6e3b72ce.svg";
export { ForwardRef as ReactComponent };